import { logger } from '@/util/logger';

import Modal from '../modules/modal.js';
const $ = window.$;

// base ReceiptViewer Constructor
function _ReceiptViewer(id, settings) {
	var that = this;
	var s = settings || {};
	this.id = id;

	this.$outer = $('#' + id);

	this.isModal = s.isModal || false;
	this.imageIsRotated = false;
	this.currentReceiptUrl = '';

	// tools selectors.
	this.$rvTools = this.$outer.find('.js-rv-tools');
	this.$zoomIn = this.$outer.find('.js-rv-zoom-in');
	this.$zoomOut = this.$outer.find('.js-rv-zoom-out');
	this.$rotateRight = this.$outer.find('.js-rv-rotate-right');
	this.$rotateLeft = this.$outer.find('.js-rv-rotate-left');

	// options selectors
	this.$rvPopout = this.$outer.find('.js-rv-popout');

	// viewer Selectors
	this.$container = this.$outer.find('.js-rv-container');
	this.$imageViewer = this.$outer.find('.js-rv-image-viewer');

	this.$rvImageViewer = this.$outer.find('.js-rv-image-viewer');
	this.$rvImage = this.$outer.find('.js-rv-image');
	this.$rvPdf = this.$outer.find('.js-rv-pdf');
	this.$rvOther = this.$outer.find('.js-rv-other');
	this.$rvOtherLink = this.$outer.find('.js-rv-other-link');
	this.$rvThumb = this.$outer.find('.js-rv-thumb');
	this.$rvThumbImage = this.$outer.find('.js-rv-thumb-image');
	this.$rvNoReceipt = this.$outer.find('.js-rv-no-receipt');

	this.fullImageUrl = '';
	this.imageMinHeight = 0;
	this.imageMinWidth = 0;
	this.imageMaxWidth = 0;
	this.imageMaxHeight = 0;
	this.imageAspectRatio = 0;
	this.isMaxZoom = false;
	this.ZOOM_FACTOR = 1.25;

	this.CONTAINER_MIN_HEIGHT = this.isModal ? 440 : 400;
	this.CONTAINER_MAX_HEIGHT = this.isModal ? this.CONTAINER_MIN_HEIGHT : 800;
	this.ZOOM_CONTROLS_OFFSET = 20;

	this.isPDFReceipt = false;
	this.isPDFPreviewOnly = false;

	// Another object that the receiptviewer window will match in height.
	this.$heightRef = $(s.heightRef) || null;
	this.imageViewerHeight = 0;

	this.cacheSelectors = function() {
		this.$outer = $('#' + id);

		if (s.heightRef) {
			this.$heightRef = $(s.heightRef);
		}

		// tools selectors.
		this.$rvTools = this.$outer.find('.js-rv-tools');
		this.$zoomIn = this.$outer.find('.js-rv-zoom-in');
		this.$zoomOut = this.$outer.find('.js-rv-zoom-out');
		this.$rotateRight = this.$outer.find('.js-rv-rotate-right');
		this.$rotateLeft = this.$outer.find('.js-rv-rotate-left');

		// options selectors
		this.$rvPopout = this.$outer.find('.js-rv-popout');

		// Viewer Selectors
		this.$container = this.$outer.find('.js-rv-container');
		this.$imageViewer = this.$outer.find('.js-rv-image-viewer');

		this.$rvImageViewer = this.$outer.find('.js-rv-image-viewer');
		this.$rvImage = this.$outer.find('.js-rv-image');
		this.$rvPdf = this.$outer.find('.js-rv-pdf');
		this.$rvOther = this.$outer.find('.js-rv-other');
		this.$rvOtherLink = this.$outer.find('.js-rv-other-link');
		this.$rvThumb = this.$outer.find('.js-rv-thumb');
		this.$rvThumbImage = this.$outer.find('.js-rv-thumb-image');
		this.$rvNoReceipt = this.$outer.find('.js-rv-no-receipt');
	};

	this.handleResize = function() {
		this.setContainerDimensions();

		if (this.isImageReceipt) {
			this.initDrag(this.$rvImage.width(), this.$rvImage.height());
		}
	};

	this.attachEvents = function() {
		$(document).off('.rv' + this.id);
		this.$outer.off('.rv' + this.id);
		this.$rvImage.off('.rv' + this.id);

		this.$rvImage.on('load.rv', function() {
			that.clearImageLoadingState();
			// this call to handlepositioning is here because for some reason IE positions the modal incorrectly until the image loads
			// when switching from a "pdf" or "other" type receipt to an "image" type receipt w/o closing the modal in between. 
			// This causes a flash of unpositioned modal (so to speak), but it works in lieu of a better solution
			if (that.isModal) {
				that.handlePositioning(that.$currentActivator);
			}
		});
		this.$outer
			.on('dblclick.rv' + this.id, '.js-rv-image-viewer', function(e) {
				if ($(e.target).hasClass('js-rv-image')) {
					if (!that.isMaxZoom) {
						that.zoomToSpot(e);
					}
				}
			})
			.on('click.rv' + this.id, '.js-rv-rotate-right', function(e) {
				if (that.isControlDisabled($(this))) {
					e.preventDefault();
					return;
				}

				that.handleRotate(false);
			})
			.on('click.rv' + this.id, '.js-rv-rotate-left', function(e) {
				if (that.isControlDisabled($(this))) {
					e.preventDefault();
					return;
				}

				that.handleRotate(true);
			})
			.on('click.rv' + this.id, '.js-rv-zoom-in', function(e) {
				if (that.isControlDisabled($(this))) {
					e.preventDefault();
					return;
				}

				that.zoom(true);
			})
			.on('click.rv' + this.id, '.js-rv-zoom-out', function(e) {
				if (that.isControlDisabled($(this))) {
					e.preventDefault();
					return;
				}

				that.zoom(false);
			})
			.on('click.rv' + this.id, '.js-rv-popout', function() {
				if ($(this).hasClass('is-disabled')) return;

				// if not pdf or image receipt, dont try to show the full image in a new window
				if (!that.isPDFReceipt && !that.isImageReceipt) return;

				window.showReceiptViewerFullImage(that.viewFullImageUrl);
			});

		window.layoutQueue.add('handleResize', this);
	};


	// Load Receipt Controls
	// -----------------------------
	this.setContainerDimensions = function() {
		if (this.$heightRef.length && window.getWindowWidth() > 769) {
			this.containerHeight = Math.min(Math.max(this.$heightRef.height(), this.CONTAINER_MIN_HEIGHT), this.CONTAINER_MAX_HEIGHT);
		} else {
			this.containerHeight = this.CONTAINER_MIN_HEIGHT;
		}

		// save a reference to container width for other calculations
		this.containerWidth = this.$container.width();

		// apply container height
		this.$container.css('height', this.containerHeight);
	};

	this.showNoReceiptState = function(msg) {
		this.clearReceiptViewer();
		this.setContainerDimensions();

		this.$rvNoReceipt.addClass('is-showing');

		this.$rvPopout.addClass('is-disabled');

		this.$rvNoReceipt.text(msg);
	};

	this.updateReceipt = function() {
		this.setContainerDimensions();
		if (this.isPDFReceipt) {
			this.$rvPdf.find('iframe').attr('height', this.containerHeight - 38);
		} else if (this.isImageReceipt) {
			this.setImageViewerHeight();
			this.setImageMinimumDimensions();
		}
	};

	this.loadNewReceipt = function (data) {
        
		var that = this;
		if (!data.receiptUrl) {
			throw new Error('No receipt url defined. Make sure receipt viewer window has valid data-receipt-url set');
		}

		if (!data.fileType) {
			throw new Error('No file type defined. Make sure receipt viewer window has valid data-file-type set');
		}

		// Clear the previous receipt and all of its data if there was one
		this.clearReceiptViewer();


		if (data.fileType === 'image' && data.imageMaxWidth == 0) {
			// There is a short delay immediately after an image is uploaded where
			// the receipt record has been created, but the image has yet to finish uploading to Azure/AWS.
			// If the page loads during that time, we will not have the image dimensions so the receipt viewer 
			// will show "Image not found". In this scenario, we should hit ReceiptImage.aspx to attempt to get
			// the receipt image dimensions.
			return new Promise(function(resolve) {
				// cut off everything from full receipt after ID param
				// Guard against undefined data or missing receiptFullUrl
                if (!data?.receiptFullUrl) {
					resolve('0,0'); // Return dimensions indicating no image found
					return;
				}
				var url = data.receiptFullUrl.substr(0, data.receiptFullUrl.indexOf('&'));

				$.get(url + '&' + 'hw=1', function(strDimensions) {
					resolve(strDimensions);
				});
			}).then(function(strDimensions) {
				// response is in the format "strHeight,strWidth"
				var arrDimensions = strDimensions.split(',');
				var height = arrDimensions[0];
				var width = arrDimensions[1];

				// this image either still hasn't processed, doesn't exist, or is corrupted
				if (width === '0') {
					that.showNoReceiptState(that.$container.data().imageNotFoundText || 'Image Not Found');
					return;
				}

				// if we got valid dimensions, update data and load receipt again
				// Guard against undefined $currentActivator to prevent TypeError
				if (that.$currentActivator && that.$currentActivator.length) {
					that.$currentActivator.data('imageMaxHeight', height);
					that.$currentActivator.data('imageMaxWidth', width);

					that.loadNewReceipt(that.$currentActivator.data());
				}
				// If $currentActivator is not available, update the data object directly and reload
				// Guard against undefined data object
				else if (data) {
					data.imageMaxHeight = height;
					data.imageMaxWidth = width;
					that.loadNewReceipt(data);
				}
			});
		}

		// store reference to current receipt URL to avoid unnecessarily reloading the same receipt later
		this.currentReceiptUrl = data.receiptUrl;

		// store separate reference to view full image URL separate from current receipt full URL as this URL can change later on.
		this.viewFullImageUrl = data.receiptFullUrl;

		this.setReceiptDisplayProperties(data);

		switch (data.fileType) {
		case 'image':
			this.setThumbnailImage(data);

			// Don't use data.receiptFullUrl because sometimes ReceiptImage.aspx rotation doesnt match CZoomImage.aspx rotation
			this.viewFullImageUrl = data.receiptUrl + '&fw=1';

			//if the receipt is a square, don't allow zoom in the next step as it hides portions of the top and bottom, CER-6176
			var doZoom = true;
			if (data.imageMaxWidth == data.imageMaxHeight) {
				doZoom = false;
            }

			// load receipt image and zoom it to level 1
			this.zoom(doZoom, {
				src: data.receiptUrl,
				isLoad: true
			});

			break;
		case 'pdf':
			var pdfSrc;

			this.setThumbnailImage(data);

			// Android Certify Mobile does not support embedding or downloading a PDF, so we display a jpg of the first page of their PDF receipt and a 
			// warning message notifying them to login via a web browser to view the full receipt.
			if (this.isPDFPreviewOnly) {
				$('.js-pdf-preview-warning').removeClass('is-hidden');

				that.viewFullImageUrl = '';
				return;
			}

			// append embedded pdf object
			pdfSrc = window.pdfService.getViewerSrc(this.viewFullImageUrl, data.locale);
			this.viewFullImageUrl = window.pdfService.getViewerSrc(this.viewFullImageUrl, data.locale);


			// append embedded pdf object
			this.$rvPdf.append('<iframe id="rv_pdf_viewer_object" "class="noPrintObject" src="' + pdfSrc + '" width="' + this.containerWidth + '" height="' + (this.containerHeight - 38) + '" style="border:0;" type="application/pdf"></iframe>');

			break;
		default:
			// append link to download file, since this is not a file type we can preview in the receipt viewer
			this.$rvOther.append('<a class="rv_download" href="' + data.receiptUrl + '" >' + data.fileName + '</a>');
			break;
		}


		if (this.isPDFPreviewOnly && this.isPDFReceipt) {
			// don't try to update view full image window. We will do that asynchronously later
		} else {
			this.updateViewFullImageWindow(this.viewFullImageUrl);
		}

		// try to re-open the receipt viewer window on first load 
		// if we think it is open, but we have just lost our reference to it.
		try {
			if (sessionStorage.updateReceiptViewerWindow === '1') {
				sessionStorage.updateReceiptViewerWindow === '0';
				window.showReceiptViewerFullImage(this.viewFullImageUrl, that.isPDFReceipt);
			}

		} catch (err) {
			logger.log(err);
		}
	};

	this.setThumbnailImage = function() {
		if (this.isPDFReceipt) {
			// use pdf.js to render a copy of the first page of the pdf as an html canvas element
			that.$outer.addClass('is-loading');
			window.pdfService.asyncAppendPreviewImage(this.$rvThumbImage, this.viewFullImageUrl, this.containerWidth, this.containerHeight - 38)
				.then(function(base64ImageSrc) {
					if (that.isPDFPreviewOnly) {
						that.viewFullImageUrl = base64ImageSrc;
						that.updateViewFullImageWindow(that.viewFullImageUrl);
					}
					that.$outer.removeClass('is-loading');
				}).catch(function(err) {
					logger.log(err);
					that.$outer.removeClass('is-loading');
				});

			if (this.isPDFPreviewOnly) {
				window.async_translate('This is a preview of the first page of a PDF receipt. To view the full receipt, log into your Certify account via a web browser.', $('.js-pdf-preview-warning'));
			}

		} else {
			// append img thumbnail
			var img = document.createElement('img');
			img.className = 'u-resp-img';
			img.src = this.viewFullImageUrl;

			// Defensive: ensure thumbnail container exists before appending (Sentry CER-22413)
			if (this.$rvThumbImage && this.$rvThumbImage.length > 0 && this.$rvThumbImage[0]) {
				this.$rvThumbImage[0].appendChild(img);
			}
		}

	};

	this.setImageViewerHeight = function() {
		this.imageViewerHeight = this.containerHeight - this.ZOOM_CONTROLS_OFFSET - 38; // -38px to subtract header height + margin
		this.$imageViewer.css('height', this.imageViewerHeight);
	};

	this.setImageMinimumDimensions = function() {
		this.imageAspectRatio = this.imageMaxWidth / this.imageMaxHeight;

		// don't allow zooming if image's max size is smaller than the container
		if (this.imageMaxWidth <= this.containerWidth && this.imageMaxHeight <= this.containerHeight) {
			this.zoomable = false;
			this.disableZoomIn();
			this.disableZoomOut();
		} else {
			this.zoomable = true;
			this.enableZoomIn();
			this.enableZoomOut();
		}

		// set min width to 90% of container width. This gives an amount to zoom out to and also
		// makes the first zoom a more reasonable size.
		if (this.imageAspectRatio > 1) {
			this.imageMinWidth = Math.min(this.imageMaxWidth, this.containerWidth * 0.9);
			this.imageMinHeight = this.imageMinWidth * (1 / this.imageAspectRatio);
		} else {
			this.imageMinHeight = Math.min(this.imageMaxHeight, this.imageViewerHeight * 0.9);
			this.imageMinWidth = this.imageMinHeight * this.imageAspectRatio;
		}
	};

	this.setReceiptDisplayProperties = function(data) {
		this.setContainerDimensions();
		switch (data.fileType) {
		case 'pdf':
			this.isPDFReceipt = true;

			if (this.isPDFPreviewOnly) {
				this.$container.css('height', this.$container.height() + 60);
			}

			this.$rvPdf.addClass('is-showing');
			this.$rvThumbImage
				.css('max-height', this.containerHeight);

			break;
		case 'image':
			this.isImageReceipt = true;

			// check if the referenced image is rotated.. This only comes into play for modals
			if (this.imageIsRotated) {
				this.imageMaxWidth = data.imageMaxHeight;
				this.imageMaxHeight = data.imageMaxWidth;
			} else {
				this.imageMaxWidth = data.imageMaxWidth;
				this.imageMaxHeight = data.imageMaxHeight;
			}

			this.setImageViewerHeight();
			this.setImageMinimumDimensions();

			this.$rvTools.addClass('is-showing');
			this.$rvImageViewer.addClass('is-showing');


			this.$rvThumbImage
				.css('max-height', this.containerHeight)
				.attr('src', this.viewFullImageUrl)
				.addClass('is-showing');

			break;
		default:
			this.$rvOther.addClass('is-showing');

			break;
		}
	};

	this.updateViewFullImageWindow = function(strUrl) {
		if (!that.isPDFReceipt && !that.isImageReceipt) return;

		// don't update view full receipt window unless the window is already open
		if (window.objReceiptViewerFullViewWindow === null || window.objReceiptViewerFullViewWindow.closed) return;

		try {
			window.showReceiptViewerFullImage(strUrl, that.isPDFReceipt);
		} catch (err) {
			logger.log(err);
		}
	};

	this.updateImagePosition = function(center, positionTop, positionLeft) {
		if (center) {
			this.$rvImage.css({
				'top': (this.imageViewerHeight - this.$rvImage.height()) / 2,
				'left': (this.containerWidth - this.$rvImage.width()) / 2
			});
		} else {
			// otherwise we are zooming
			this.$rvImage.css({
				'top': positionTop,
				'left': positionLeft
			});
		}
	};

	this.getRotatedImageSrc = function(rotateLeft) {
		var str = this.$rvImage[0].src;

		// remove any existing rotation params
		str = this.clearRotateParam(str);

		if (rotateLeft) {
			return str += '&rl=1';
		}

		return str += '&rr=1';
	};

	this.clearRotateParam = function(src) {
		return src.replace('&rl=1', '').replace('&rr=1', '');
	};

	this.appendCacheBreakParam = function(src) {
		if (src.indexOf('msjeirud') > -1) {
			// replace paramater if it has already been added
			const start = src.indexOf('rnd=') + 4;
			const end = src.indexOf('msjeirud') - start;
			const randomString = src.substr(start, end);
			return src.replace(randomString, Math.random());
		}
		src = src + '&rnd=' + Math.random() + 'msjeirud';
		return src;
	};

	this.enableZoomIn = function() {
		if (this.zoomable) {
			this.$rvImage.removeClass('is-max-zoom');

			this.$zoomIn
				.removeClass('is-disabled')
				.removeAttr('style');

			this.isMaxZoom = false;
		}
	};

	this.disableZoomIn = function() {
		this.$rvImage.addClass('is-max-zoom');
		this.$zoomIn
			.addClass('is-disabled')
			.removeAttr('style');

		this.isMaxZoom = true;
	};

	this.enableZoomOut = function() {
		if (this.zoomable) {
			this.$zoomOut
				.removeClass('is-disabled')
				.removeAttr('style');
		}
	};

	this.disableZoomOut = function() {
		this.isMaxZoom = false;
		this.$zoomOut
			.addClass('is-disabled')
			.removeAttr('style');
	};

	this.getZoomParam = function(param, src) {
		return window.getURLParameter(param, src.substr(src.indexOf('?')));
	};

	this.setZoomLevel = function(src, val) {
		var currentZoomLevel = this.getZoomParam('zz', src);
		// apply the zoom to our URL, so we can load a new image that's really resized
		if (currentZoomLevel !== null) {
			return src.replace('&zz=' + currentZoomLevel, '&zz=' + val);
		} else {
			return src + '&zz=' + val;
		}
	};
	this.setZoomHeight = function(src, val) {
		var currentZoomHeight = this.getZoomParam('zh', src);
		// apply the zoom to our URL, so we can load a new image that's really resized
		if (currentZoomHeight !== null) {
			return src.replace('&zh=' + currentZoomHeight, '&zh=' + val);
		} else {
			return src + '&zh=' + val;
		}
	};
	this.setZoomWidth = function(src, val) {
		var currentZoomWidth = this.getZoomParam('zw', src);
		// apply the zoom to our URL, so we can load a new image that's really resized
		if (currentZoomWidth !== null) {
			return src.replace('&zw=' + currentZoomWidth, '&zw=' + val);
		} else {
			return src + '&zw=' + val;
		}
	};

	this.getZoomedHeight = function(zoomWidth) {
		return zoomWidth * (1 / this.imageAspectRatio);
	};


	this.zoomToSpot = function(e) {
		this.zoom(true, {
			offsetX: e.offsetX / (this.$rvImage.width() / 2),
			offsetY: e.offsetY / (this.$rvImage.height() / 2)
		});
	};

	this.initDrag = function(width, height) {
		var boundingBox = [];
		var xOff = this.$imageViewer.offset().left;
		var yOff = this.$imageViewer.offset().top;

		// x1, y1, x2, y2
		boundingBox.push(xOff - width + 80);
		boundingBox.push(yOff - height + 80);
		boundingBox.push(xOff + this.containerWidth - 80);
		boundingBox.push(yOff + this.imageViewerHeight - 80);

		this.$rvImage.draggable({
			'containment': boundingBox
		});

	};
	this.zoom = function(zoomIn, settings) {
		var s = settings || {};
		var rvImg = this.$rvImage[0];

		// if rvimg is null exit early https://emburse.atlassian.net/browse/CER-24728
		// this is likely transient due to new images being loaded in and the old image element being removed, 
		if (!rvImg) {
			return;
		}
		var strSrc = s.src || rvImg.src;
		var zoomLevel = parseInt(this.getZoomParam('zz', strSrc), 10) || 0;

		var currentWidth = this.$rvImage.width() || this.imageMinWidth;
		var currentHeight = this.$rvImage.height() || this.imageMinHeight;
		var currentPosLeft = parseInt(rvImg.style.left, 10) || 0;
		var currentPosTop = parseInt(rvImg.style.top, 10) || 0;

		var zoomedWidth = 0;
		var zoomedHeight = 0;
		var newpositionLeft = 0;
		var newPositionTop = 0;

		var offsetX = s.offsetX || 1;
		var offsetY = s.offsetY || 1;

		var centerImage = false;

		if (s.isLoad || s.rotationPending) {
			centerImage = true;
			currentWidth = this.imageMinWidth;
			currentHeight = this.imageMinHeight;
			this.enableZoomIn();
		}

		if (s.rotationPending) {
			rvImg.src = '';
		} else {
			strSrc = this.clearRotateParam(strSrc);
		}

		if (zoomIn) {
			zoomLevel++;

			zoomedWidth = Math.min(currentWidth * this.ZOOM_FACTOR, this.imageMaxWidth);
			zoomedHeight = this.getZoomedHeight(zoomedWidth);

			if (zoomedWidth === this.imageMaxWidth) {
				this.disableZoomIn();
			}
			// Keep the image centered relative to its current or offset position on zoom.
			newpositionLeft = currentPosLeft - (((zoomedWidth - currentWidth) / 2) * offsetX);
			newPositionTop = currentPosTop - (((zoomedHeight - currentHeight) / 2) * offsetY);

			// enable zoom out control if it isn't already since we know we will be zooming in
			this.enableZoomOut();

		} else {
			// we will revert everything to default on zoom out
			zoomLevel = 0;
			zoomedWidth = this.imageMinWidth;
			zoomedHeight = this.imageMinHeight;

			centerImage = true;

			// Enable zoom in control if it is not already
			this.enableZoomIn();

			// disable zoom out control because we are at max zoom out
			this.disableZoomOut();
		}

		// do a check here to make sure that we have a valid zoom width and height. If not, throw the missing receipt message
		if (isNaN(zoomedWidth)) {
			// throw missing receipt error
			this.showNoReceiptState(this.$container.data().imageNotFoundText || 'Image Not Found');
			return;
		}

		// Zoom image and append a random param to break cache
        
		strSrc = this.setZoomLevel(strSrc, zoomLevel);
		strSrc = this.appendCacheBreakParam(strSrc);
		strSrc = this.setZoomWidth(strSrc, zoomedWidth);
		strSrc = this.setZoomHeight(strSrc, zoomedHeight);

		this.setImageLoadingState();
		this.$rvImage
			.css({
				'height': zoomedHeight,
				'width': zoomedWidth
			})
			.attr('src', strSrc);

		this.initDrag(zoomedWidth, zoomedHeight);

		this.updateImagePosition(centerImage, newPositionTop, newpositionLeft);

		if (s.rotationPending) {
			this.updateViewFullImageWindow(this.viewFullImageUrl);
		}
	};

	this.handleRotate = function(rotateLeft) {
		// get all the info we need to perform the rotation

		var intTempW = 0;
		var zoomSettings = {};

		if (this.isModal) {
			this.$currentActivator.toggleClass('is-rotated');
		}

		//Swap the max width and height values.
		intTempW = this.imageMaxWidth;

		this.imageMaxWidth = this.imageMaxHeight;
		this.imageMaxHeight = intTempW;

		this.setImageMinimumDimensions();

		zoomSettings.src = this.getRotatedImageSrc(rotateLeft);
		zoomSettings.rotationPending = true;

		// ---------------- perform zoom to 0 with new aspect ratio.
		this.zoom(false, zoomSettings);
	};


	// State Config methods
	// -------------------------------
	this.setImageLoadingState = function () {
		this.$outer.addClass('is-loading');
		this.$imageViewer.showComponentLoader();
		this.$rvThumb.showComponentLoader();
	};

	this.clearImageLoadingState = function () {
		this.$outer.removeClass('is-loading');
		this.$imageViewer.hideComponentLoader();
		this.$rvThumb.hideComponentLoader();
	};
	this.isControlDisabled = function($elem) {
		return $elem.hasClass('is-disabled') || this.$outer.hasClass('is-loading');
	};

	this.clearReceiptViewer = function() {
		this.imageMinHeight = 0;
		this.imageMinWidth = 0;
		this.imageMaxHeight = 0;
		this.imageMaxWidth = 0;
		this.imageViewerHeight = 0;
		this.containerWidth = 0;
		this.containerHeight = 0;
		this.currentReceiptUrl = '';
		this.viewFullImageUrl = '';

		this.isPDFReceipt = false;
		this.isImageReceipt = false;

		this.$imageViewer
			.css('height', '')
			.removeClass('is-showing');

		this.$rvImage
			.attr('src', '')
			.css({
				'position': '',
				'width': '',
				'height': ''
			});

		this.$rvTools.removeClass('is-showing');

		this.$rvOther.find('a').remove()
			.removeClass('is-showing');

		this.$rvPdf.find('iframe').remove();
		this.$rvPdf.removeClass('is-showing');

		this.$rvThumb.removeClass('is-showing');
		this.$rvThumbImage.empty();

		this.$rvNoReceipt.removeClass('is-showing');

		this.$rvPopout
			.removeClass('is-showing is-disabled');

		this.$rvTools.removeClass('is-showing');

		$('.js-pdf-preview-warning').addClass('is-hidden');

		this.clearImageLoadingState();

		this.isImageReceipt = false;
	};

	this.init = function() {
		this.cacheSelectors();
		this.attachEvents();

		try {
			this.isPDFPreviewOnly = this.$container.data().isCertifyMobile && this.$container.data().isAndroid;
		} catch (e) {
			// do nothing: default is false
		}

		$(window).on('unload', function() {
			if (window.objReceiptViewerFullViewWindow === null || window.objReceiptViewerFullViewWindow.closed) {
				sessionStorage.updateReceiptViewerWindow = '0';
				return;
			}            
			// if view full image window is open, set a session storage var to try and open it with current receipt on init.
			// This is necessary because if a user navigates away from the page while working on a receipt, the reference to the
			// window will be lost and the window won't update when the receipt in the receipt viewer changes

			try {
				sessionStorage.updateReceiptViewerWindow = '1';
			} catch (err) {
				// do nothing
			}
		});

		if (typeof this.afterInit === 'function') {
			this.afterInit();
		}
	};
}

// Static ReceiptViewer Constructor
window.ReceiptViewerStatic = function(id, settings) {
	_ReceiptViewer.call(this, id, settings);

	this.afterInit = function() {
		var that = this;
		var data = this.$container.data();

		var hasReceiptLoaded = (function() {
			if (that.$rvImageViewer.hasClass('is-showing')) return true;
			if (that.$rvPdf.hasClass('is-showing')) return true;
			if (that.$rvOther.hasClass('is-showing')) return true;

			return false;
		})();

		if (data && data.receiptUrl && data.receiptUrl.length) {
			if (hasReceiptLoaded && data.receiptUrl == this.currentReceiptUrl) {
				this.updateReceipt();
			} else {
				this.loadNewReceipt(data);
			}
		} else {
			this.showNoReceiptState(this.$container.data().noReceiptText || 'No Receipt Selected');
		}

	};
};

// Modal Receipt Viewer Constructor
window.ModalReceiptViewer = function(id, settings) {
	var s = settings || {};
	s.isModal = true;

	Modal.call(this, id, s);
	_ReceiptViewer.call(this, id, s);

	this.$currentActivator = null;

	this.positionFixed = false;

	this.beforeOpen = function($activator) {
		$('body')
			.addClass('has-rv-open')
			.attr('data-target', $activator.data().target);

		var data = $activator.data();

		this.imageIsRotated = $activator.hasClass('is-rotated');

		if ($activator.hasClass('is-rotated')) {
			this.imageMaxWidth = data.imageMaxHeight;
			this.imageMaxHeight = data.imageMaxWidth;
		} else {
			this.imageMaxWidth = data.imageMaxWidth;
			this.imageMaxHeight = data.imageMaxHeight;
		}

	};

	this.afterOpen = function ($activator) {
		var data = $activator.data();
		this.loadNewReceipt(data);
	};

	this.afterClose = function() {

		this.clearReceiptViewer();

		$('body')
			.removeClass('has-rv-open')
			.removeAttr('data-target');

		this.$outer.css({
			'top': '',
			'left': '',
			'width': '',
			'height': ''
		});
	};

	this.setIndicatorPosition = function(offset, showOnRight) {
		if (showOnRight) {
			this.$indicator
				.css('top', offset)
				.addClass('is-to-left')
				.removeClass('is-to-right');
		} else {
			this.$indicator
				.css('top', offset)
				.addClass('is-to-right')
				.removeClass('is-to-left');
		}
	};

    

}